import { mailApiGet, mailApiPost } from "./client";
import { MAIL_ACCOUNTS_FETCH_TIMEOUT_MS } from "@/lib/boot/mailBootConstants";
import type {
  MailAccountConnectPayload,
  MailAccountSummary,
  MailProviderPreset,
} from "../types/mail";

export function fetchMailAccounts() {
  return mailApiGet<{ success: boolean; accounts: MailAccountSummary[] }>(
    "accounts/list.php",
    { timeoutMs: MAIL_ACCOUNTS_FETCH_TIMEOUT_MS }
  );
}

export function fetchMailProviders() {
  return mailApiGet<{
    success: boolean;
    providers: MailProviderPreset[];
    oauthNote?: string;
  }>("accounts/providers.php");
}

export function testMailConnection(payload: MailAccountConnectPayload) {
  return mailApiPost<{ success: boolean; message: string }>(
    "accounts/test-connection.php",
    payload
  );
}

export function saveMailAccount(payload: MailAccountConnectPayload) {
  return mailApiPost<{ success: boolean; message: string; account: MailAccountSummary }>(
    "accounts/save.php",
    payload
  );
}

export function deleteMailAccount(accountId: number) {
  return mailApiPost<{ success: boolean; message: string; accountId: number }>(
    "accounts/delete.php",
    { accountId }
  );
}

export function reorderMailAccounts(accountIds: number[]) {
  return mailApiPost<{ success: boolean; accountIds: number[] }>(
    "accounts/reorder.php",
    { accountIds }
  );
}

export function setDefaultMailAccount(accountId: number) {
  return mailApiPost<{ success: boolean; accountId: number }>(
    "accounts/set-default.php",
    { accountId }
  );
}
